import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        <h2>🎯 What is an AWS GameDay?</h2>
        <div className="content-grid">
          <div className="content-card">
            <h3>A Gamified Challenge</h3>
            <p>AWS GameDay is a team-based challenge where participants solve real-world AWS problems in a risk-free environment.</p>
          </div>
          <div className="content-card">
            <h3>Learn by Doing</h3>
            <p>An excellent opportunity to learn by practicing, work as a team, and most importantly, have fun!</p>
          </div>
          <div className="content-card">
            <h3>Hybrid Format</h3>
            <p>Each user group hosts a local meetup where teams gather. The competition takes place online, but the experience is shared in person.</p>
          </div>
        </div>

        <div className="event-details">
          <h3>🌍 The Event</h3>
          <p>This hybrid event is open to all AWS User Groups across Europe, aiming to bring our communities together for a collaborative, practical, and fun experience.</p>
          <div className="highlights">
            <span className="highlight">🗓️ March 17, 2026</span>
            <span className="highlight">🕕 6:00 PM CET</span>
            <span className="highlight">🌍 Europe</span>
            <span className="highlight">🤝 Hybrid Format</span>
            <span className="highlight">👥 Team-Based</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;